(function () {
  try {
    var MOBILE_MAX = 767;
    var CLASS_HIDE = 'tp-hide-trustedshops-mobile';
    var raf = 0;

    // Para no enganchar observers duplicados
    var observedMenuEl = null;
    var observedCartEl = null;
    var observedQuickViewEl = null;

    function isMobile() {
      return window.innerWidth <= MOBILE_MAX;
    }

    // ✅ Menú abierto = existe la page del menú con aria-hidden="false"
    function menuOpen() {
      return !!document.querySelector('drawer-menu-page[data-page-id="Menu"][aria-hidden="false"]');
    }

    // ✅ Carrito abierto = #CartDrawer tiene clase is-opened (lo has visto tú)
    function cartOpen() {
      var cart = document.getElementById('CartDrawer');
      return !!(cart && cart.classList.contains('is-opened'));
    }

    function quickViewOpen() {
  // El componente existe como <quick-view id="Quick-view"> en vuestro tema
  var qv = document.getElementById('Quick-view');
  if (!qv) return false;

  // Estados típicos del tema Aurora / sidebar
  if (qv.classList.contains('is-opened') || qv.classList.contains('is-open')) return true;

  // Fallback: cuando el botón de cerrar aparece con is-opened
  if (qv.querySelector('.quick-view__close-button.is-opened')) return true;

  // Fallback genérico: si el quick view no está hidden
  var ariaHidden = qv.getAttribute('aria-hidden');
  if (ariaHidden === 'false') return true;

  return false;
  }

    function setState() {
      if (!document.body) return;

      if (!isMobile()) {
        document.body.classList.remove(CLASS_HIDE);
        return;
      }
      var isCartPage = (window.location && window.location.pathname === '/cart');
      document.body.classList.toggle(CLASS_HIDE, isCartPage || menuOpen() || cartOpen() || quickViewOpen());
    }

    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        ensureObservers();
        setState();
      });
    }

    function observeAttrs(el) {
      if (!el) return;
      new MutationObserver(schedule).observe(el, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'class', 'open']
      });
    }

    // 🔑 Reengancha observers si el menú/cart se re-renderizan
    function ensureObservers() {
      var menuEl = document.querySelector('drawer-menu-page[data-page-id="Menu"]');
      if (menuEl && menuEl !== observedMenuEl) {
        observedMenuEl = menuEl;
        observeAttrs(menuEl);
      }

      var cartEl = document.getElementById('CartDrawer');
      if (cartEl && cartEl !== observedCartEl) {
        observedCartEl = cartEl;
        observeAttrs(cartEl);
      }

      var qvEl = document.getElementById('Quick-view');
      if (qvEl && qvEl !== observedQuickViewEl) {
      observedQuickViewEl = qvEl;
      observeAttrs(qvEl);
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureObservers();

      // Captura clics/taps (abrir/cerrar menú o carrito) sin observers globales pesados
      document.addEventListener('click', schedule, true);
      document.addEventListener('touchend', schedule, { capture: true, passive: true });
      window.addEventListener('resize', schedule);

      // “Seguro” por si el menú se inyecta después
      var tries = 0;
      var t = setInterval(function () {
        ensureObservers();
        setState();
        tries++;
        if (tries > 20) clearInterval(t); // ~10s
      }, 500);

      setState();
    });
  } catch (e) {}
})();